// extracted by mini-css-extract-plugin
module.exports = {"search":"Search_search__3tPN1","bar":"Search_bar__kFeMf","load":"Search_load__KQXHs"};